import { combineReducers } from 'redux';
import { handleActions } from 'redux-actions';
import * as Actions from '../actions/CompanyManagementOrganizer';

const detailCompanyOrganizerReducer = handleActions({
    [Actions.GetDetailCompanyOrganizerRequested]: (state) => ({
        ...state,
        isFetching: true,
    }),
    [Actions.GetDetailCompanyOrganizerReceived]: (state, action) => ({
        ...state,
        isFetching: false,
        success: true,
        data: action.payload,
    }),
    [Actions.GetDetailCompanyOrganizerReceivedFailure]: (state, action) => ({
        ...state,
        isFetching: false,
        success: false,
        errors: action.payload.errors,
    }),
    [Actions.ClearGetDetailCompanyOrganizer]: (state) => ({
        ...state,
        isFetching: false,
        data: {},
        success: false,
        errors: {},
    }),
}, {
    isFetching: false,
    data: {},
    errors: {},
    success: false,
});

const editCompanyOrganizerReducer = handleActions({
    [Actions.EditCompanyOrganizerRequested]: (state) => ({
        ...state,
        isFetching: true,
    }),
    [Actions.EditCompanyOrganizerReceived]: (state, action) => ({
        ...state,
        isFetching: false,
        data: action.payload,
        success: true,
    }),
    [Actions.EditCompanyOrganizerReceivedFailure]: (state, action) => ({
        ...state,
        isFetching: false,
        errors: action.payload.errors,
        success: false,
    }),
    [Actions.ClearEditCompanyOrganizer]: (state) => ({
        ...state,
        isFetching: false,
        data: {},
        errors: {},
        success: false,
    }),
}, {
    isFetching: false,
    data: {},
    errors: {},
    success: false,
});

const commonInfoCompanyReducer = handleActions({
    [Actions.GetCommonInfoCompanyRequested]: (state) => ({
        ...state,
        isFetching: true,
    }),
    [Actions.GetCommonInfoCompanyRequestedReceived]: (state, action) => ({
        ...state,
        isFetching: false,
        data: action.payload,
        success: true,
    }),
    [Actions.GetCommonInfoCompanyRequestedReceivedFailure]: (state, action) => ({
        ...state,
        isFetching: false,
        errors: action.payload,
        success: false,
    }),
}, {
    isFetching: false,
    data: {},
    errors: {},
    success: false,
});

const detailCompanyOrganizerForSideBarReducer = handleActions({
    [Actions.GetDetailCompanyOrganizerForSideBarRequested]: (state) => ({
        ...state,
        isFetching: true,
    }),
    [Actions.GetDetailCompanyOrganizerForSideBarReceived]: (state, action) => ({
        ...state,
        isFetching: false,
        success: true,
        data: action.payload,
    }),
    [Actions.GetDetailCompanyOrganizerForSideBarReceivedFailure]: (state, action) => ({
        ...state,
        isFetching: false,
        success: false,
        errors: action.payload.errors,
    }),
    [Actions.ClearGetDetailCompanyOrganizerForSideBar]: (state) => ({
        ...state,
        isFetching: false,
        data: {},
        success: false,
        errors: {},
    }),
}, {
    isFetching: false,
    data: {},
    errors: {},
    success: false,
});

export default combineReducers({
    detailCompanyOrganizer: detailCompanyOrganizerReducer,
    editCompanyOrganizer: editCompanyOrganizerReducer,
    commonInfoCompany: commonInfoCompanyReducer,
    detailCompanyOrganizerForSideBar: detailCompanyOrganizerForSideBarReducer,
});
